import { pendingStyles } from "components/styled";
import styled from "styled-components";

export const LeaderboardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 48px;
  border-radius: var(--rounding-radius-xxxl, 48px);
  background: var(--fill-secondary, rgba(204, 187, 184, 0.16));
  padding: var(--spacing-space-24, 24px) var(--spacing-space-24, 24px)
    var(--spacing-space-24, 24px) var(--spacing-space-64, 64px);

  @media (max-width: 1024px) {
    margin: 0 -24px;
    width: calc(100% + 48px);
    display: block;
    padding: var(--spacing-space-24, 24px);
  }
`;

export const LeaderboardLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 1024px) {
    text-align: center;
    margin-bottom: 40px;
  }
`;

export const LeaderboardLeftContestOver = styled.div`
  && {
    padding: 34px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .button-text {
      color: var(--text-primary);
    }
  }
`;

export const TrumbnailGroup = styled.div`
  display: flex;
  align-items: center;
  img {
    margin-left: -12px;
    width: 32px;
    height: 32px;
  }
`;

export const RatingEpicItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 32px;
  margin: 0 auto 0 20px;
  img {
    width: 32px;
    height: 32px;
    object-fit: contain;
    object-position: center;
  }

  @media (max-width: 1024px) {
    min-height: 32px;
    span {
      display: none;
    }
    img {
      width: 32px;
      height: 32px;
    }
  }
  @media (max-width: 768px) {
    span {
      display: block;
    }
  }
  @media (max-width: 528px) {
    margin: 0 auto 0 10px;
    span {
      display: none;
    }
    &.in-modal {
      margin: 0 auto 0 30px;
    }
  }
`;

export const TeamRating = styled.div`
  padding: 32px 32px 40px;
  min-height: 448px;
  position: relative;
  cursor: pointer;

  border-radius: var(--rounding-radius-xl, 24px);
  background: var(--fill-elevated, rgba(204, 187, 184, 0.16));
  box-shadow: 0px 8px 24px 0px rgba(51, 20, 0, 0.08),
    0px 4px 8px 0px rgba(51, 20, 0, 0.04);
  .bg {
    position: absolute;
    width: 932px;
    height: 932px;
    z-index: -1;
    right: -250px;
    top: -250px;
  }
  .bg2 {
    display: none;
  }

  @media (min-width: 1919px) {
    ${RatingEpicItem} {
      margin-left: 30px;
    }
  }

  @media (max-width: 1024px) {
    padding: 24px 24px 32px;
    min-height: 366px;
    .bg {
      display: none;
    }
    .bg2 {
      display: block;
      position: absolute;
      object-fit: contain;
      object-position: center;
      top: -363px;
      left: -72%;
      right: 0;
      bottom: 0;
      transform: scale(0.82);
      z-index: -1;
    }
  }
  ${pendingStyles}
`;

export const RatingItem = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 0;
  &.pointer {
    cursor: pointer;
  }
  & + & {
    margin-top: 12px;
  }
  &.small-gaps {
    & + & {
      margin-top: 8px;
    }
  }
  @media (max-width: 1024px) {
    padding: 8px 0;
  }
  @media (max-width: 528px) {
    gap: 8px;
  }
`;

export const RatingNum = styled.div`
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.5px;
  color: #72706e;
  font-variation-settings: "wght" 600;
  overflow: hidden;
  width: max-content;
  overflow: hidden;
  flex-shrink: 0;
  min-width: 22px;
  &.referral {
    position: relative;
    background: rgba(204, 187, 184, 0.16);
    border-radius: 50%;
    display: flex;
    align-items: center;
    font-variation-settings: "wght" 600;
    color: var(--text-primary);
    width: 28px;
    height: 28px;
    justify-content: center;
  }
`;

export const RatingTeamInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 104px;
  width: 104px;
  span {
    margin-bottom: 0;
  }

  @media (max-width: 1024px) {
    max-width: 86px;
    width: 86px;
    span {
      max-width: 74px;
    }

    &.wide {
      max-width: 100%;
      span {
        max-width: 100%;
      }
    }
  }
  @media (max-width: 380px) {
    max-width: 100px;
  }

  &.full-width {
    width: 100%;
    max-width: 100%;
    span {
      max-width: 100%;
    }
  }
  &.sm {
    width: 80px;
    max-width: 80px;
  }
`;

export const RatingTotals = styled.div<{ pnl?: number }>`
  background: ${({ pnl }) => {
    if (!pnl) return "#CCBBB829";
    if (pnl > 0) return "var(--fill-positive-bg, rgba(71, 89, 62, 0.72))";
    if (pnl < 0) return "var(--fill-negative-bg)";
  }};
  color: ${({ pnl }) => {
    if (!pnl) return "#000000";
    if (pnl > 0) return "#45BE33";
    if (pnl < 0) return "#E54796";
  }};
  border-radius: 16px;
  height: 24px;
  padding: 4px 8px;
  font-style: italic;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.5px;
  margin-left: auto;
  white-space: nowrap;
`;

export const YourRank = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.5px;
  color: rgba(66, 61, 60, 0.64);
`;
